module.exports = __webpack_public_path__ + "202336:0ab57eca5a8d3a1f525a/img/Luminary-homepage-3-L-1024x576.258b81c.jpg";